<template>
  <div class="grid-item" v-for="item in items"
    :class="item.portfolioSpecial ? 'special' : ''">
    <img :src="item.portfolioImg">
    <div class="description">
      <h2 v-if="item.portfolioTitleLink">
        <a :href="item.portfolioTitleLink"
          target="_blank">{{ item.portfolioTitle }}
        </a>
      </h2>
      <h2 v-else>
        {{ item.portfolioTitle }}
      </h2>
      <h3 v-if="item.portfolioSubtitleLink">
        <a :href="item.portfolioSubtitleLink"
          target="_blank">{{ item.portfolioSubtitle }}
        </a>
      </h3>
      <h3 v-else>
        {{ item.portfolioSubtitle }}
      </h3>
      <a v-if="item.portfolioLink" :href="item.portfolioLink"
        target="_blank" class="btn btn-demo">
        <span class="icon"></span>
        {{ item.portfolioLinkText }}
      </a>
      <p>
        {{ item.portfolioDescription }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PortfolioItem',
  props: {
    portfolioImg: String,
    portfolioTitle: String,
    portfolioTitleLink: String,
    portfolioSubtitle: String,
    portfolioSubtitleLink: String,
    portfolioDescription: String,
    portfolioLink: String,
    portfolioLinkText: String,
    portfolioArticleLink: String,
    portfolioSpecial: Boolean
  },
  data() {
    return {
      items: [
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/commondesign.png",
          "portfolioTitle": "Design system for suite of Humanitarian websites",
          "portfolioTitleLink": "",
          "portfolioSubtitle": "",
          "portfolioSubtitleLink": "",
          "portfolioDescription": "Drupal base theme and sub theme with single directory components, and Wordpress theme providing visual, UI and code consistency across a range of websites.",
          "portfolioLink": "https://web.brand.unocha.org/demo",
          "portfolioLinkText": "View demo",
          "portfolioArticleLink": "",
          "portfolioSpecial": 1
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/unocha.png",
          "portfolioTitle": "Drupal site builds for UNOCHA",
          "portfolioSubtitle": "",
          "portfolioDescription": "Drupal 9 and 10 site builds and upgrades for UNOCHA, Reliefweb and others. Theming from designs, project planning, documentation and training, testing, deployment, code reviews, maintenance, and ongoing feature development.",
          "portfolioLink": "https://unocha.org",
          "portfolioLinkText": "View website",
          "portfolioSpecial": 0
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/audits.png",
          "portfolioTitle": "Accessibility and Performance Advocacy",
          "portfolioSubtitle": "",
          "portfolioDescription": "Testing, data gathering, reporting and remediation. Data-driven performance and accessibility improvements.",
          "portfolioLink": "",
          "portfolioLinkText": "View demo",
          "portfolioSpecial": 0
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/whd2022.png",
          "portfolioTitle": "Site build and theme for UNOCHA World Humanitarian Day 2022",
          "portfolioSubtitle": "",
          "portfolioDescription": "",
          "portfolioLink": "https://2022.worldhumanitarianday.org",
          "portfolioLinkText": "View website",
          "portfolioSpecial": 0
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/itext.png",
          "portfolioTitle": "Drupal site builds, frontend development, and ecommerce",
          "portfolioSubtitle": "",
          "portfolioDescription": "",
          "portfolioLink": "",
          "portfolioLinkText": "View demo",
          "portfolioSpecial": 0
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/game.png",
          "portfolioTitle": "JiGS Interactive Game System",
          "portfolioTitleLink": "https://github.com/Techbot/JiGS",
          "portfolioSubtitle": "The Drupal MMORPG and Trading Game engine",
          "portfolioSubtitleLink": "https://www.emc23.com/taxonomy/term/25",
          "portfolioDescription": "The Eclectic Meme Conspiracy Online (EMC Online) is an online, persistent, 2d, tiled, RPG, multiplayer, virtual world. JiGS is an integrated gaming system (client and server) built for and in tandem with EMC Online.",
          "portfolioLink": "https://www.eclecticmeme.com",
          "portfolioLinkText": "View demo",
          "portfolioSpecial": 1
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/plates/consumer.gif",
          "portfolioTitle": "PhaserJs Game Design and Development",
          "portfolioSubtitle": "",
          "portfolioDescription": "",
          "portfolioLink": "http://techbot.github.io/projects",
          "portfolioLinkText": "View games",
          "portfolioSpecial": 0
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/umami-ember-homepage.png",
          "portfolioTitle": "Umami Headless Drupal with Contenta CMS, EmberJs",
          "portfolioSubtitle": "",
          "portfolioDescription": "The task was to create the Umami Drupal OOTB designs using ContentaCMS as the data enpoint, in whatever consumer flavour takes your fancy. We chose EmberJs.",
          "portfolioLink": "https://github.com/contentacms/contenta_ember",
          "portfolioLinkText": "View repo",
          "portfolioSpecial": 0
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/feu-concept-speakers.png",
          "portfolioTitle": "Web design ideas for Frontend United 2018",
          "portfolioSubtitle": "",
          "portfolioDescription": "Web design ideas delivered in HTML/CSS for implementation in Drupal 8 by other volunteers for Frontend United 2018 in Utrecht.",
          "portfolioLink": "",
          "portfolioLinkText": "View demo",
          "portfolioSpecial": 0
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/cmc-concepts.png",
          "portfolioTitle": "Design process",
          "portfolioSubtitle": "",
          "portfolioDescription": "Lo-fi wireframes, navigation design, component style tile, high fidelity graphic page design, and Drupal 7 theme",
          "portfolioLink": "http://cmc.ie/",
          "portfolioLinkText": "View website",
          "portfolioSpecial": 0
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/patternlab.png",
          "portfolioTitle": "Design-in-the-browser",
          "portfolioSubtitle": "",
          "portfolioDescription": " Patternlab integration, Drupal 8 implementation for website redesign",
          "portfolioLink": "",
          "portfolioLinkText": "View demo",
          "portfolioSpecial": 0
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/living-styleguide.png",
          "portfolioTitle": "Living Styleguide",
          "portfolioSubtitle": "",
          "portfolioDescription": "KSSnode styleguide and Drupal 8 OpenSocial integration",
          "portfolioLink": "https://www.getopensocial.com/blog/open-source-technology/creating-living-style-guide-open-social",
          "portfolioLinkText": "View blog",
          "portfolioSpecial": 0
        },
        {
          "portfolioImg": "https://www.emc23.com/sites/default/files/images/techbot.io/hospital-wayfinder.png",
          "portfolioTitle": "Design concepts",
          "portfolioSubtitle": "",
          "portfolioDescription": "High fidelity graphic mock ups for Hospital website tender, intended to be built in Drupal 7. Desktop and mobile homepage, and wayfinder app concept",
          "portfolioLink": "",
          "portfolioLinkText": "View demo",
          "portfolioSpecial": 0
        }
      ]
    }
  }
}
</script>
<style>

</style>
